import { Dropdown, MenuProps } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useCallback, useMemo, MouseEvent } from "react";
import { useDefaultDeleteModal } from "../../../lib/hooks/defaultDeleteModal";
import { deleteContract } from "../../../acions/accounts/contracts";

type TableActionsProps = {
  menuKeys: string[];
  id: string;
  status: number;
  reloadData: () => void;
  navigateToAccount: (id: string) => void;
};

export const TableActions = ({
  menuKeys,
  id,
  status,
  reloadData,
  navigateToAccount,
}: TableActionsProps) => {
  const { openDeleteModal } = useDefaultDeleteModal(deleteContract, reloadData);

  const onEdit = useCallback(
    (e: MouseEvent<HTMLInputElement>): void => {
      e.stopPropagation();
      navigateToAccount(id);
    },
    [id, navigateToAccount],
  );

  const onDelete = useCallback(
    (e: MouseEvent<HTMLInputElement>): void => {
      e.stopPropagation();
      openDeleteModal(id, "Delete account");
    },
    [id, openDeleteModal],
  );

  const items: MenuProps["items"] = useMemo(() => {
    const values: MenuProps["items"] = [];

    menuKeys.includes("1") &&
      values.push({
        key: "1",
        label: <div onClick={onEdit}>Edit</div>,
      });

    if (status === 7 && menuKeys.includes("2")) {
      values.push({
        key: "2",
        label: <div onClick={onDelete}>Delete</div>,
      });
    }

    return values;
  }, [menuKeys, onDelete, onEdit, status]);

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <EllipsisOutlined onClick={(e) => e.stopPropagation()} />
    </Dropdown>
  );
};
